import { MouseEvent, ReactNode } from "react";
import { useLocation, useNavigate } from "@/lib/router-compat";
import { scrollToHash } from "@/components/ScrollToTop";

interface HashLinkProps {
  to: string;
  className?: string;
  children: ReactNode;
  onClick?: () => void;
}

/**
 * Link that works for in-page anchors ("/#solucoes") from ANY route,
 * without a full page reload.
 */
export function HashLink({ to, className, children, onClick }: HashLinkProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const [path, hash] = to.split("#");
  const targetPath = path || "/";

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    onClick?.();

    if (!hash) {
      navigate(targetPath);
      return;
    }

    if (location.pathname === targetPath) {
      window.history.replaceState(window.history.state, "", `${targetPath}#${hash}`);
      // Run after the router/menu settle so nothing resets the scroll.
      setTimeout(() => scrollToHash(hash), 80);
    } else {
      navigate(`${targetPath}#${hash}`);
    }
  };

  return (
    <a href={to} className={className} onClick={handleClick}>
      {children}
    </a>
  );
}
